
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./BidConfirmation.css";

const BidConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const sessionName = location.state?.sessionName || "Your bid";
  const productCount = location.state?.productCount || 0;

  return (
    <div className="bid-confirmation-page">
      <div className="bid-confirmation-card">
        {/* tick circle */}
        <div className="bid-confirmation-icon">
          <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
            <circle cx="22" cy="22" r="22" fill="#2da44e"/>
            <path d="M12 22l8 8 12-14" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <div className="bid-confirmation-title">
          Bid submitted!
        </div>
        <div className="bid-confirmation-message">
          Your bid for <strong>{sessionName}</strong> has been successfully submitted
          {productCount > 0 && <> for <strong>{productCount} product{productCount > 1 ? "s" : ""}</strong></>}.
        </div>

        <button
          onClick={() => navigate("/bids/all")}
          className="bid-confirmation-primary-button"
        >
          Back to bids
        </button>
        <button
          onClick={() => navigate("/bids/submitted")}
          className="bid-confirmation-secondary-button"
        >
          View submitted bids
        </button>
      </div>
    </div>
  );
};

export default BidConfirmation;
